module.exports = __webpack_public_path__ + "img/not-found.da6d68bd.svg";